import React, { useEffect } from "react";

function useTitle(title) {
  useEffect(() => {
    document.title = `${title} - PrimeCap Sensometer`;
  }, [title]);
}

export default useTitle;
